import { cache } from '../../../api/client';

export function updateCache(key: string, data: any): void {
  (cache.config.store as any).setItem(key, {
    expires: Date.now() + (cache.config?.maxAge ?? 0),
    data: { status: 'success', data },
  });
}
